import React, { Component } from 'react';
import {
  Image,
  ImageBackground,
  Platform,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  Button,
  View,
  BackHandler,
} from 'react-native';

import EonnButton from '../components/button';
import EonnDropdown from '../components/dropdown';
import EonnLink from '../components/link';
import EonnField from '../components/field';
import EonnTitle from '../components/title';
import { mstyles } from '../constants/MainStyles';

const styles = StyleSheet.create({
  techHeader: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 20,
  },
  header: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 20,
    width: '100%',
  },
  logo: {
    width: '100%',
    height: null,
    aspectRatio: 2.27,
    resizeMode: 'contain',
    marginBottom: 10,
  },
  logoContainer: {
    position: 'relative',
    width: '100%',
    marginBottom: 20,
  },
  title: {
    fontSize: 40,
    lineHeight: 40,
    textAlign: 'center',
    marginTop: 0,
    marginBottom: 5,
    maxWidth: '80vw'
  },
  subtitle: {
    fontSize: 16,
    lineHeight: 16,
    textAlign: 'center',
    marginTop: 0,
    marginBottom: 20,
    maxWidth: '80vw'
  },
  sContent: {
    paddingTop: 0,
    paddingBottom: 30,
    flexDirection: 'column',
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  rateBox: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 10,
  },
  rate1: {
    fontSize: 20,
    lineHeight: 22,
    marginRight: 5,
  },
  rate2: {
    fontSize: 20,
    lineHeight: 22,
  },
  rateDollar: {
    fontSize: 16,
  },
  about: {
    fontSize: 18,
    marginTop: 10,
    marginBottom: 20,
    textAlign: 'center',
  },
});

export default class Screen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showRequired: false,
      err: "",
    };
    console.log(global.user);
  }

  render() {

    const years = ["Other"];
    const currentYear = new Date().getFullYear();
    for (let i = 1995; i <= currentYear + 1; i++) {
      years.push(i);
    }
    years.reverse();

    const makes = ['Other', 'Acura', 'Alfa Romeo', 'Audi', 'Bentley', 'BMW', 'Bugatti', 'Buick', 'Cadillac', 'Chevrolet', 'Chrysler', 'Dodge', 'Ferrari', 'Fiat', 'Ford', 'Genesis', 'GMC', 'Honda', 'Hyundai', 'Infiniti', 'Jaguar', 'Jeep', 'Kia', 'Lamborghini', 'Land Rover', 'Lexus', 'Lincoln', 'Lotus', 'Maserati', 'Mazda', 'Mercedes-Benz', 'Mini', 'Mitsubishi', 'Nissan', 'Porsche', 'Ram', 'Rolls-Royce', 'Subaru', 'Tesla', 'Toyota', 'Volkswagen', 'Volvo'];

    const hasTechLink = !!global.techLink;

    return (
      <ScrollView style={mstyles.sContainer} contentContainerStyle={mstyles.sContent}>
      <ImageBackground
        source={require('../assets/images/bg4.jpg')}
        style={styles.sContent}
      >
        {hasTechLink && global.techLinkBid ? (
          <EonnTitle>Video consultation with {global.techLinkBid.t_name}</EonnTitle>
        ) : (
          <View style={styles.header}>
            <View style={styles.logoContainer}>
              <Image
                source={require('../assets/images/intro-logo.png')}
                style={styles.logo}
              />
            </View>
            <Text style={[mstyles.mfont,styles.title]}>Online vehicle diagnosis</Text>
          </View>
        )}

        {this.state.err
          ? <Text style={mstyles.err}>{this.state.err}</Text>
          : null
        }

        <Text style={[mstyles.text, mstyles.center]}>Expert auto advice is just a few {Platform.OS === 'web' ? 'clicks' : 'taps'} away! To start, please enter the year, make, and model of your vehicle: </Text>
        <EonnDropdown
          items={years}
          onChange={value => Object.assign(global.user, { vehicle: { ...global.user.vehicle, year: value } })}
          showRequired={this.state.showRequired}
          value={global.user.vehicle?.year}
          label="Vehicle Year"
          placeholder="Select a year"
        />
        <EonnDropdown
          items={makes}
          onChange={value => Object.assign(global.user, { vehicle: { ...global.user.vehicle, make: value } })}
          showRequired={this.state.showRequired}
          value={global.user.vehicle?.make}
          label="Vehicle Make"
          placeholder="Select a make"
        />
        <EonnField
          onChange={value => Object.assign(global.user, { vehicle:{ ...global.user.vehicle, model: value } }) }
          showRequired={this.state.showRequired}
          value={global.user.vehicle?.model}
          >Vehicle Model</EonnField>
        <EonnField
          onChange={value => Object.assign(global.user, { vehicle: { ...global.user.vehicle, mileage: value } })}
          showRequired={this.state.showRequired}
          value={global.user.vehicle?.mileage}
          inputMode={"numeric"}
          keyboardType={"numeric"}
        >Vehicle Mileage</EonnField>
        <EonnButton
          onPress={() => {
              this.setState({ err: "" });
              this.props.navigation.navigate("C_Issue1");
          }}
          showRequired={() => this.setState({ showRequired: true })}
          required={() => [
            global.user.vehicle?.year,
            global.user.vehicle?.make,
            global.user.vehicle?.model,
            global.user.vehicle?.mileage,
          ]}
          style={hasTechLink ? {marginBottom: 10} : undefined}
        >
          Next
        </EonnButton>
        {hasTechLink && (
          <EonnButton
            navigationProps={this.props.navigation}
            screen={'C_TechInfo'}
            white={true}
            style={{marginTop: 10}}
          >
            Back
          </EonnButton>
        )}
        </ImageBackground>
      </ScrollView>
    );
  }
}